{
  "title": "Welcome {{name}}, to react using react-i18next fully type-safe",
  "description": {
    "part1": "This is a simple example.",
    "part2": "😉"
  },
  "userMessagesUnread_one": "You have {{count}} unread message.",
  "userMessagesUnread_other": "You have {{count}} unread messages."
}